var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { eventUpdateSubject, sportsbookList, eventMapping, marketMapping, marketIdMapping, sportsbookFilter, highlightedEvents, sportsSummerySubject, sportsSummery, customCompetitionGroupNames, languageFile } from "../store/sportsbook.store";
import { ApiService } from '../lib/http.service';
import { handicappedMarkets, highLightedMarketCategories } from "../definitions/constants/market-categories.constant";
import { env } from "../definitions/global.vars";
import { SportbookWS } from "./websocket.services";
import _ from "lodash";
import { BetSlipList } from "../store/betslip.store";
import { addToBetSlip, initializeBetSlip, restoreBetSlip } from "./betslip.services";
import { modalServiceSubject } from "../components/modal/modal";
import { eventEndedStatuses } from "../definitions/constants/event-result-type";
import { commentUpdateSubject, getMemberInfo } from "./societyWon.services";
import { member } from "../store/login.store";
import { ServerDate } from "../lib/misc.functions";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
export var sportsbookApi = env.currentbook_api + "/sportsbook/";
export var myHighLightedMarketGroups = {};
export var myHighLightedMarketGroups2 = {};
export var mobileHighLightedMarket = {};
function restoreHighLightedMarketGroups() {
    for (var _i = 0, _a = Object.entries(highLightedMarketCategories); _i < _a.length; _i++) {
        var _b = _a[_i], s = _b[0], v = _b[1];
        myHighLightedMarketGroups[s] = highLightedMarketCategories[s].filter(function (m) { return !m.row || m.row !== 2; }).slice(0, 3);
        myHighLightedMarketGroups2[s] = highLightedMarketCategories[s].filter(function (m) { return !m.row || m.row !== 2; });
        mobileHighLightedMarket[s] = highLightedMarketCategories[s].filter(function (m) { return !m.row || m.row !== 2; }).slice(0, 1);
    }
}
restoreHighLightedMarketGroups();
var sportsOrders = {
    'futbol_1': 1,
    'basketbol_1': 2,
    'tenis_1': 3,
    'duello_1': 4,
    'voleybol_1': 5,
    'buz-hokeyi_1': 6,
    'hentbol_1': 7,
    'snooker_1': 8,
    'mma_1': 9,
    'futbol_2': 10,
    'basketbol_2': 11,
    'tenis_2': 12,
    'duello_2': 13,
    'voleybol_2': 14,
    'buz-hokeyi_2': 15,
    'hentbol_2': 16,
    'snooker_2': 17,
    'mma_2': 18
};
export var popularCompetitionList = ["3042", "566", "1861", "18278410", "3013", "3014", "3015", "1957", "1958", "1959", "538", "539", "564", "1840", "545", "553", "2991", "543", "544", "572", "541", "542", "1876", "548", "549", "1871"];
export function getLanguageFile(lng) {
    return __awaiter(this, void 0, void 0, function () {
        var apiService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiService = new ApiService();
                    return [4 /*yield*/, apiService.start('get', env.sportsbook_api + "/translate/".concat(lng, "_language.json"), null, false, 60000)
                            .then(function (response) {
                            if (response.status === true) {
                                languageFile[lng] = response.data;
                            }
                        })
                            .catch(function (e) {
                            console.error(e);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getSportSummery() {
    return __awaiter(this, void 0, void 0, function () {
        var summer, summeryList, _loop_1, _i, _a, _b, s, v;
        return __generator(this, function (_c) {
            summer = _.groupBy(sportsbookList, function (item) {
                return "".concat(item.sS, "___").concat(item.sId, "___1___").concat(item.iLE, "___").concat(item.sN, "___").concat(item.sNId);
            });
            summeryList = [];
            _loop_1 = function (s, v) {
                var i = s.split('___');
                if (i[2] != '2') {
                    var isExist = summeryList.filter(function (el) { return el.sportSlug === i[0] && Number(1) === Number(i[2]); });
                    if (isExist.length > 0) {
                        if (isExist[0].activeGame !== true && Number(i[3]) === Number(1)) {
                            isExist[0].activeGame = true;
                        }
                        isExist[0].count += v.length;
                        if (Number(i[3]) === Number(1)) {
                            isExist[0]["liveEventCount"] = v.length;
                        }
                    }
                    else {
                        summeryList.push({
                            activeGame: Number(i[3]) === Number(1),
                            count: v.length,
                            eventType: i[2],
                            isLiveEvent: Number(i[3]) === Number(1),
                            liveEventCount: Number(i[3]) === Number(1) ? v.length : 0,
                            order_id: sportsOrders["".concat(i[0], "_").concat(i[2])],
                            sportId: i[1],
                            sportName: i[4],
                            sportSlug: i[0],
                            sportNameId: i[5],
                        });
                    }
                }
            };
            for (_i = 0, _a = Object.entries(summer); _i < _a.length; _i++) {
                _b = _a[_i], s = _b[0], v = _b[1];
                _loop_1(s, v);
            }
            summeryList = _.orderBy(summeryList, ['order_id']);
            Object.assign(sportsSummery, summeryList);
            sportsSummerySubject.next(true);
            return [2 /*return*/];
        });
    });
}
export function isHalfNumber(oN) {
    if (!oN)
        return true;
    var match = oN.match(/[\d.]+/);
    return !!match && parseFloat(match[0]) % 1 === 0.5;
}
var YeniMarket = [
    '4-57'
];
var withoutSpecialOddValues = [
    '4-717'
];
var replaceSpecialOffValues = [
    '4-736'
];
export function marketNameTransform(outcomeName, specialOddsValue, market) {
    if (market === void 0) { market = null; }
    if (handicappedMarkets.includes(market.mST)) {
        if (Number(specialOddsValue) < 0) {
            outcomeName = outcomeName + ' (0 : ' + (Number(specialOddsValue) * -1).toString() + ')';
        }
        else {
            if (specialOddsValue) {
                outcomeName = outcomeName + ' (' + specialOddsValue.toString() + ' : 0)';
            }
        }
        return outcomeName;
    }
    else if (market && YeniMarket.includes(market.mST)) {
        return market.mN + ' : ' + outcomeName;
    }
    else if (market && (market.mN.toLowerCase().includes('maçın geri kalanını kim kazanır') ||
        market.mN.toLowerCase().includes('maçın kalanını kim kazanır') ||
        market.mN.toLowerCase().includes('sıradaki golü kim atar') ||
        withoutSpecialOddValues.includes(market.mST))) {
        return outcomeName;
    }
    else if (market && (market.mN === 'Maç Sonucu')) {
        return "".concat(outcomeName);
    }
    else if (market && (market.mST === '2-718')) {
        return "".concat(outcomeName.split(' ')[0], "/").concat(outcomeName.split(' ')[1]);
    }
    else if (market && (market.mN.toLowerCase().includes('i̇lk yarı kalanını kim kazanır'))) {
        return "".concat(outcomeName);
    }
    else {
        return "".concat(outcomeName, " ").concat((specialOddsValue === '.5' ? '0.5' : market.sOV) || '');
    }
}
export function setFilterCompetitions(competitionId) {
    if (competitionId === 'clear') {
        sportsbookFilter.filterCompetition = [];
    }
    else {
        if (competitionId) {
            for (var _i = 0, _a = competitionId.toString().split(','); _i < _a.length; _i++) {
                var cid = _a[_i];
                var index = sportsbookFilter.filterCompetition.indexOf(cid);
                if (index === -1) {
                    sportsbookFilter.filterCompetition.push(cid);
                }
                else {
                    sportsbookFilter.filterCompetition.splice(index, 1);
                }
            }
        }
    }
    window.scrollTo(0, 0);
}
export function setFilterMBS(mbs) {
    if (mbs === 'clear') {
        sportsbookFilter.filterMBS = [];
    }
    else {
        var index = sportsbookFilter.filterMBS.indexOf(mbs);
        if (index === -1) {
            sportsbookFilter.filterMBS.push(mbs);
        }
        else {
            sportsbookFilter.filterMBS.splice(index, 1);
        }
    }
    window.scrollTo(0, 0);
}
export function setFilterDays(day) {
    if (day === 'clear') {
        sportsbookFilter.filterDays = [];
    }
    else {
        var index = sportsbookFilter.filterDays.indexOf(day);
        if (index === -1) {
            sportsbookFilter.filterDays.push(day);
        }
        else {
            sportsbookFilter.filterDays.splice(index, 1);
        }
    }
    window.scrollTo(0, 0);
}
function getHighLightedEvents() {
    return __awaiter(this, void 0, void 0, function () {
        var apiServices;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiServices = new ApiService();
                    return [4 /*yield*/, apiServices.start('get', env.sportsbook_api + '/get-highlighted-events/', null, false)
                            .then(function (response) {
                            var temp = [];
                            for (var _i = 0, _a = Object.entries(response.data); _i < _a.length; _i++) {
                                var _b = _a[_i], k = _b[0], v = _b[1];
                                if (eventMapping[k.toString()]) {
                                    eventMapping[k.toString()].customStyle = v;
                                    temp.push(eventMapping[k.toString()]);
                                }
                            }
                            highlightedEvents.push.apply(highlightedEvents, _.orderBy(temp, ['eventDate']).slice(0, 8));
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function generatePreCompetitionsGroupList(shownSportsBook, orderBy, reGroupedCompetitionsEventDate, _groupBy) {
    if (orderBy === void 0) { orderBy = null; }
    if (reGroupedCompetitionsEventDate === void 0) { reGroupedCompetitionsEventDate = false; }
    if (_groupBy === void 0) { _groupBy = null; }
    var competitionList = [];
    var groupedByCompetition = _.groupBy(shownSportsBook, function (item) {
        // item.competitionName = item.competitionName.replace(new RegExp(',', 'g'), '')
        if (item.cId) {
            if (customCompetitionGroupNames[item.cId.toString()]) {
                item.cGN = customCompetitionGroupNames[item.cId.toString()]['name'];
                item.competitionPriority = customCompetitionGroupNames[item.cId.toString()]['priority'];
            }
        }
        return [item.sId, item.sS, item.coN];
    });
    // @ts-ignore
    for (var _i = 0, _a = Object.entries(groupedByCompetition); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var group = groupedByCompetition[key];
        var reGroupedCompetitions = _.groupBy(value, function (item) {
            return [item.cN];
        });
        var customPriority = 99999999;
        if (isMobile) {
            if (popularCompetitionList.includes(group[0].cId.toString())) {
                customPriority = 1;
            }
            else {
                customPriority = 99999999;
            }
        }
        else {
            // if (popularCompetitionList.includes(key.split(',')[6].toString())) {
            //     customPriority = 1;
            // } else {
            //     customPriority = 99999999;
            // }
        }
        competitionList.push({
            sportId: key.split(',')[0],
            sportSlug: key.split(',')[1],
            countryName: key.split(',')[2],
            // competitionGroupName: key.split(',')[3].replace('İ', 'III').replace('Ç', 'CCC').replace('Ş', 'SSS'),
            competitionGroupNameId: key.split(',')[3],
            // competitionGroupNameId: group[0].cGNId,
            competitions: reGroupedCompetitions,
            count: group.length,
            competitionPriority: customPriority,
            competitionVolume: group.reduce(function (a, b) {
                return a + b['mOC'];
            }, 0),
            competitionCount: {
                pre: group.filter(function (el) { return el.bP.toString() !== "1"; }).length,
                live: group.filter(function (el) { return el.bP.toString() === "1"; }).length,
            }
        });
    }
    return _.orderBy(competitionList, ['competitionPriority']);
}
export function generateCompetitionGroupList(shownSportsBook, orderBy, reGroupedCompetitionsEventDate, _groupBy) {
    var _a;
    if (orderBy === void 0) { orderBy = null; }
    if (reGroupedCompetitionsEventDate === void 0) { reGroupedCompetitionsEventDate = false; }
    if (_groupBy === void 0) { _groupBy = null; }
    var competitionList = [];
    var groupedByCompetition = _.groupBy(shownSportsBook, function (item) {
        // item.competitionName = item.competitionName.replace(new RegExp(',', 'g'), '')
        if (item.cId) {
            if (customCompetitionGroupNames[item.cId.toString()]) {
                item.cGN = customCompetitionGroupNames[item.cId.toString()]['name'];
                item.competitionPriority = customCompetitionGroupNames[item.cId.toString()]['priority'] || 'AXYA';
            }
        }
        var countryName = item.coN ? item.coN.replace(new RegExp(',', 'g'), '').replace(new RegExp(' ', 'g'), '_') : '';
        var competitionGroupName = item.cGN ? item.cGN.replace(new RegExp(',', 'g'), '') : '';
        if (reGroupedCompetitionsEventDate == true) {
            return [item.sId, item.sS, countryName, competitionGroupName, item.cGId, item.cGNId, item.cId, item.eD];
        }
        else if (_groupBy && _groupBy.includes('coN')) {
            return [item.sId, item.sS, countryName, competitionGroupName, item.cGId];
        }
        else {
            return [item.sId, item.sS, countryName, competitionGroupName, item.cGId, item.cGNId];
        }
    });
    // @ts-ignore
    for (var _i = 0, _b = Object.entries(groupedByCompetition); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], value = _c[1];
        var group = groupedByCompetition[key];
        var reGroupedCompetitions = void 0;
        if (_groupBy) {
            reGroupedCompetitions = _.groupBy(value, function (item) {
                return [item.cN];
            });
        }
        else {
            reGroupedCompetitions = _.groupBy(value, function (item) {
                return [item.cN];
            });
        }
        // let customPriority = customCompetitionPriorty.find((ex: any) => ex.competitionGroupId.toString() === key.split(',')[4].toString())
        //
        //
        // for (const [_key, _value] of Object.entries(customCompetitionGroupNames)) {
        //     // @ts-ignore
        //     if (key.split(',')[3] === _value['name']) {
        //         // @ts-ignore
        //         customPriority = {"competitionPriority": _value['priority']};
        //     }
        // }
        var customPriority = 99999999;
        if (isMobile) {
            if (_groupBy && _groupBy.includes('eD')) {
                customPriority = 99999999999;
            }
            else {
                if (popularCompetitionList.includes(group[0].cId.toString())) {
                    customPriority = 1;
                }
                else {
                    customPriority = 99999999;
                }
            }
        }
        else {
            if (_groupBy && _groupBy.includes('eD')) {
                customPriority = 99999999999;
            }
            else {
                if (popularCompetitionList.includes(group[0].cId.toString())) {
                    customPriority = 1;
                }
                else {
                    customPriority = 99999999;
                }
            }
            // if (popularCompetitionList.includes(key.split(',')[6].toString())) {
            //     customPriority = 1;
            // } else {
            //     customPriority = 99999999;
            // }
        }
        competitionList.push({
            sportId: key.split(',')[0],
            sportSlug: key.split(',')[1],
            countryName: key.split(',')[2],
            competitionGroupName: key.split(',')[3].replace('İ', 'III').replace('Ç', 'CCC').replace('Ş', 'SSS'),
            competitionGroupNameId: (_a = key.split(',')[5]) !== null && _a !== void 0 ? _a : group[0].cNId,
            competitions: reGroupedCompetitions,
            count: group.length,
            competitionPriority: customPriority,
            competitionVolume: group.reduce(function (a, b) {
                return a + b['mOC'];
            }, 0),
            competitionCount: {
                pre: group.filter(function (el) { return el.bP.toString() !== "1"; }).length,
                live: group.filter(function (el) { return el.bP.toString() === "1"; }).length,
            }
        });
        // competitionPriority: customPriority ? Number(customPriority.competitionPriority) : 99999999,
        //     competitionVolume: customPriority ? customPriority.competitionVolume : group.reduce((a, b) => {
        //     return a + b['marketOutcomeCount'];
        // }, 0),
    }
    // if (orderBy) {
    //     return _.orderBy(competitionList, orderBy)
    // }
    return _.orderBy(competitionList, ['competitionPriority']);
    // return _.orderBy(competitionList, ['competitionVolume'], ['desc']).slice(0,7).concat(_.orderBy(_.orderBy(competitionList, ['competitionVolume'], ['desc']).slice(7,9999999), ['competitionGroupName'], ['asc']))
}
export function removeEndedEvents() {
    var apiService2 = new ApiService();
    apiService2.start('get', env.sportsbook_api + '/events/?fields=eventId', null, false)
        .then(function (response) {
        var updated = [];
        if (response.status && response.data.length > 0) {
            var eventIds_1 = response.data.map(function (el) {
                return Number(el.eventId);
            });
            var mustRemove = sportsbookList.filter(function (event) { return !eventIds_1.includes(Number(event.eventId)); });
            for (var _i = 0, mustRemove_1 = mustRemove; _i < mustRemove_1.length; _i++) {
                var mr = mustRemove_1[_i];
                mr.isRemoved = true;
                if (mr.isAdded) {
                    addToBetSlip(mr, null, null, 'removeEvent');
                }
                updated.push(mr.eventId);
            }
        }
        if (updated.length > 0) {
            eventUpdateSubject.next(updated);
        }
    });
}
// export async function getAlarmSubscriptions() {
//     const apiService = new ApiService();
//     apiService.timeout = 3000;
//     return await apiService.start('post', env.scores + '/api/get-subscriptions/', {token: Storage.get('token')}, true)
//         .then((res: any) => {
//             return res
//         }).catch((e: any) => {
//             console.error(e)
//             return null
//         })
// }
export function fillHighLightedMarkets(event, selectedHlCode) {
    if (selectedHlCode === void 0) { selectedHlCode = null; }
    if (selectedHlCode === null) {
        event.highlightedMarkets = {};
    }
    var hLCodes = highLightedMarketCategories[event.sS];
    if (hLCodes) {
        var isLiveOrPre_1 = Number(event.bP) === 0 ? 'pre' : 'live';
        hLCodes.map(function (hlMap) {
            var hlCode = hlMap[isLiveOrPre_1];
            if (hlCode === selectedHlCode || selectedHlCode === null) {
                var hlCodeArray = hlCode.split('-');
                var hlMarketSubType_1 = Number(hlCodeArray[0]);
                var specialOddsValue_1;
                if (hlCodeArray.length > 1) {
                    specialOddsValue_1 = hlCodeArray[1];
                }
                var availableMarkets = marketMapping[event.eventId].filter(function (m) {
                    var _a;
                    if (['5520', '5500'].includes(m.mST) && !isHalfNumber((_a = m.marketOutcome[0]) === null || _a === void 0 ? void 0 : _a.oN))
                        return; // if Total Goals (5500) is not half number skip it.
                    if ((specialOddsValue_1 === undefined || Number(m.sOV) === Number(specialOddsValue_1)) &&
                        (Number(m.mST) === hlMarketSubType_1) &&
                        ((Number(m.mS) < 0 || (Number(m.mS) === 1)))) {
                        return m;
                    }
                });
                if (availableMarkets.length > 0) {
                    if (availableMarkets.length === 1) {
                        event.highlightedMarkets[hlCode] = availableMarkets[0];
                    }
                    else {
                        for (var _i = 0, availableMarkets_1 = availableMarkets; _i < availableMarkets_1.length; _i++) {
                            var market = availableMarkets_1[_i];
                            var diff = 0;
                            var diff2 = 0;
                            var bestChoice = false;
                            if (event.highlightedMarkets[hlCode]) {
                                diff = Math.abs(Number(event.highlightedMarkets[hlCode].marketOutcome[0].fOW) - Number(event.highlightedMarkets[hlCode].marketOutcome[1].fOW));
                                diff2 = Math.abs(Number(market.marketOutcome[0].fOW) - Number(market.marketOutcome[1].fOW));
                                if (diff2 < diff && diff2 > 0) {
                                    bestChoice = true;
                                }
                            }
                            if (event.highlightedMarkets[hlCode] === undefined || bestChoice) {
                                event.highlightedMarkets[hlCode] = market;
                            }
                        }
                    }
                }
            }
        });
    }
}
export function checkAndAddHighLightedMarkets(event, market) {
    var hLCodes = highLightedMarketCategories[event.sS];
    var isLiveOrPre = Number(event.bP) === 0 ? 'pre' : 'live';
    if (hLCodes) {
        var isSuitable = hLCodes.filter(function (el) { return el[isLiveOrPre] === market.mST || el[isLiveOrPre] === market.mST + '-' + market.sOV; });
        if (isSuitable.length > 0) {
            isSuitable = isSuitable[0];
            var hlCode = isSuitable[isLiveOrPre];
            var hlCodeArray = hlCode.split('-');
            var hlMarketSubType_2 = Number(hlCodeArray[0]);
            var specialOddsValue_2;
            if (hlCodeArray.length > 1) {
                specialOddsValue_2 = hlCodeArray[1];
            }
            var availableMarkets = marketMapping[event.eventId].filter(function (m) {
                var _a;
                if (['5520', '5500'].includes(m.mST) && !isHalfNumber((_a = m.marketOutcome[0]) === null || _a === void 0 ? void 0 : _a.oN))
                    return; // if Total Goals (5500) is not half number skip it.
                if ((specialOddsValue_2 === undefined || Number(m.sOV) === Number(specialOddsValue_2)) &&
                    (Number(m.mST) === hlMarketSubType_2) &&
                    ((Number(m.mS) < 0 || (Number(m.mS) === 1)))) {
                    return m;
                }
            });
            if (availableMarkets.length === 0) {
                if (!event.highlightedMarkets) {
                    event.highlightedMarkets = {};
                }
                event.highlightedMarkets[hlCode] = market;
            }
            else {
                for (var _i = 0, availableMarkets_2 = availableMarkets; _i < availableMarkets_2.length; _i++) {
                    var market_1 = availableMarkets_2[_i];
                    var diff = 0;
                    var diff2 = 0;
                    var bestChoice = false;
                    if (event.highlightedMarkets && event.highlightedMarkets[hlCode]) {
                        diff = Math.abs(Number(event.highlightedMarkets[hlCode].marketOutcome[0].fOW) - Number(event.highlightedMarkets[hlCode].marketOutcome[1].fOW));
                        diff2 = Math.abs(Number(market_1.marketOutcome[0].fOW) - Number(market_1.marketOutcome[1].fOW));
                        if (diff2 < diff && diff2 > 0) {
                            bestChoice = true;
                        }
                        else {
                            bestChoice = false;
                        }
                    }
                    if (event.highlightedMarkets && event.highlightedMarkets[hlCode] === undefined || bestChoice) {
                        event.highlightedMarkets[hlCode] = market_1;
                    }
                }
            }
        }
    }
}
export function updateEventComments(data, action) {
    if (action === 'add' && data && data.obj_id) {
        if (data.content_type === 1) {
            var event_1 = eventMapping[String(data.obj_id)];
            if (event_1 && event_1.comments && data.member_id !== member.id) {
                getMemberInfo({ member_id: data.member_id }).then(function (res) {
                    if (res && res.length > 0) {
                        data.member = {
                            member_id: res[0].member_id,
                            photo: res[0].photo,
                            nick_name: res[0].nick_name,
                        };
                    }
                    if (event_1.comments) {
                        event_1.comments.unshift(data);
                        commentUpdateSubject.next(Number(event_1.eventId));
                    }
                });
            }
        }
        if (data.content_type === 4 && (!member || data.member_id !== member.id)) {
            getMemberInfo({ member_id: data.member_id }).then(function (res) {
                if (res && res.length > 0) {
                    data.member = {
                        member_id: res[0].member_id,
                        photo: res[0].photo,
                        nick_name: res[0].nick_name,
                    };
                }
            });
        }
    }
    if (action === 'remove' && data) {
        var event_2 = eventMapping[String(data.obj_id)];
        if (event_2 && event_2.comments) {
            event_2.comments = event_2.comments.filter(function (el) { return Number(el.post_id) !== Number(data.post_id); });
            commentUpdateSubject.next(Number(event_2.eventId));
        }
    }
    if (action === 'update' && data) {
        var event_3 = eventMapping[String(data.obj_id)];
        if (event_3 && event_3.comments) {
            commentUpdateSubject.next(Number(event_3.eventId));
        }
    }
}
//
// export async function fillEventStatistics(ids: any) {
//     const apiService = new ApiService();
//     return await apiService.start('get', env.sportsbook_api + '/get-event-statistics/?events=' + ids.join(','), null, false)
//         .then((response: any) => {
//             if (response.status === true) {
//                 if (response.data.length > 0) {
//                     response.data.forEach((stat: any) => {
//                         statisticsMap[stat.eventId] = stat;
//                     });
//                 }
//             }
//         })
//         .catch((e: any) => {
//             console.error(e)
//         })
// }
// export async function getCustomCompetitionPriorty() {
//     let cachedData = Storage.get('customCompetitionPriorty');
//     if (cachedData) {
//         Object.assign(customCompetitionPriorty, cachedData);
//     }
//
//     const apiService = new ApiService();
//     apiService.start('get', env.website_url + '/json/competition_priority.json', null, false)
//         .then((res: any) => {
//             Object.assign(customCompetitionPriorty, res);
//         })
// }
//
// export async function getCustomCompetitionNames() {
//     let cachedData = Storage.get('customCompetitionGroupNames');
//     if (cachedData) {
//         Object.assign(customCompetitionGroupNames, cachedData);
//     }
//
//     const apiService = new ApiService();
//     apiService.start('get', env.cdn_url + '/json/competition_map.json', null, false)
//         .then((res: any) => {
//             Object.assign(customCompetitionGroupNames, res);
//         })
// }
export function reOrganizeEventRatios() {
    sportsbookList.forEach(function (event) {
        event.hasCustomratio = false;
        marketMapping[event.eventId.toString()].forEach(function (market) {
            market.marketOutcome.forEach(function (outcome) {
                if (Number(outcome.fOW) < Number(outcome.fOW) || (member && member.additional_ratio && Number(member.additional_ratio) > 0)) {
                    if (member && member.additional_ratio && Number(member.additional_ratio) > 0) {
                        outcome.fixedOdds = Number(outcome.fOW) + Number(member.additional_ratio);
                    }
                    outcome.customOdds = Number(outcome.fOW);
                    event.hasCustomratio = true;
                }
                else {
                    outcome.customOdds = null;
                }
            });
        });
    });
}
export function prepairSportsbookList(setLoading, response) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.data.forEach(function (event) {
                        // for( let [k,v] of Object.entries(EVENT_MAP)){
                        //   delete Object.assign(event, {[k]: event[v] })[v];
                        //   delete event[k];
                        // }
                        eventMapping[event.eventId.toString()] = event;
                        if (event.markets) {
                            event.hasCustomratio = false;
                            marketMapping[event.eventId.toString()] = event.markets;
                            event.markets.forEach(function (market) {
                                if (!marketIdMapping[event.eventId.toString()]) {
                                    marketIdMapping[event.eventId.toString()] = {};
                                }
                                market.marketOutcome.forEach(function (outcome) {
                                    if (Number(outcome.fOW) < Number(outcome.fOW) || (member && member.additional_ratio && Number(member.additional_ratio) > 0)) {
                                        if (member && member.additional_ratio && Number(member.additional_ratio) > 0) {
                                            outcome.fOW = Number(outcome.fOW) + Number(member.additional_ratio);
                                        }
                                        outcome.customOdds = Number(outcome.fOW);
                                        event.hasCustomratio = true;
                                    }
                                    else {
                                        outcome.customOdds = null;
                                    }
                                });
                                marketIdMapping[event.eventId.toString()][market.marketId.toString()] = market;
                            });
                            event.markets = [];
                            fillHighLightedMarkets(event);
                        }
                        sportsbookList.push(eventMapping[event.eventId.toString()]);
                        if (event.sS === 'football') {
                            highlightedEvents.push(event);
                        }
                    })
                    // Start WSS Updater
                ];
                case 1:
                    _a.sent();
                    // Start WSS Updater
                    return [4 /*yield*/, SportbookWS.connect(SportbookWS.SPORTBOOK, null, true)];
                case 2:
                    // Start WSS Updater
                    _a.sent();
                    return [4 /*yield*/, getSportSummery().then(function () {
                            if (BetSlipList.length === 0) {
                                restoreBetSlip();
                                initializeBetSlip();
                            }
                            setTimeout(function () {
                                setLoading(false);
                            }, 1000);
                        })];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var SportsBookService = function (props) {
    var _a = useState(true), isLoading = _a[0], setLoading = _a[1];
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var apiService = new ApiService();
    useEffect(function () {
        if (sportsbookList.length === 0) {
            // getCustomCompetitionPriorty();
            // getCustomCompetitionNames();
            (function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: 
                            // await apiService
                            //     .start('get', popularCompetitionUrl, null, false)
                            //     .then((response: any) => {
                            //         popularCompetition.push(...response)
                            //     })
                            return [4 /*yield*/, apiService
                                    .start('get', sportsbookApi, null, false, 60000)
                                    .then(function (response) {
                                    if (response.status && response.data) {
                                        // getRatioCampaignInfo().then((res:any)=>{
                                        //   prepairSportsbookList(setLoading, response, res);
                                        // }).catch(()=>{
                                        //   prepairSportsbookList(setLoading, response);
                                        // });
                                        prepairSportsbookList(setLoading, response);
                                    }
                                })
                                    .catch(function (e) {
                                    setLoading(false);
                                    setTimeout(function () {
                                        modalServiceSubject.next({
                                            title: 'Bağlantı hatası',
                                            content: 'Lütfen internet bağlantınız kontrol edin. İnternet Bağlantınız yok ya da çok zayıf.',
                                            confirm: {
                                                sure: {
                                                    label: 'Tekrar Dene',
                                                    action: function () {
                                                        window.location.reload();
                                                    }
                                                }
                                            }
                                        });
                                    }, 500);
                                })];
                            case 1:
                                // await apiService
                                //     .start('get', popularCompetitionUrl, null, false)
                                //     .then((response: any) => {
                                //         popularCompetition.push(...response)
                                //     })
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            })();
        }
    }, []);
    if (isLoading) {
        return _jsxs("div", __assign({ className: "App splash" }, { children: [_jsx("br", {}, void 0), " ", t('loading')] }), void 0);
    }
    return (_jsx(_Fragment, { children: props.children }, void 0));
};
export default SportsBookService;
export function compireEventKeys(exEvent, newEvent) {
    var isUpdated = false;
    for (var _i = 0, _a = Object.entries(newEvent); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (exEvent && exEvent[key] !== value) {
            if (key === 'bP' && Number(exEvent[key]) === 0 && Number(value) === 1) {
                fillHighLightedMarkets(exEvent);
            }
            if (key !== 'markets') {
                exEvent[key] = value;
                isUpdated = true;
            }
        }
    }
    return isUpdated;
}
export function compireMarketKeys(event, exMarket, newMarket) {
    var isUpdated = false;
    if (!exMarket && newMarket) {
        marketIdMapping[newMarket.e][newMarket.marketId.toString()] = newMarket;
        marketMapping[newMarket.e].push(newMarket);
        checkAndAddHighLightedMarkets(event, marketIdMapping[newMarket.e][newMarket.marketId.toString()]);
        isUpdated = true;
    }
    else if (exMarket && newMarket) {
        for (var _i = 0, _a = Object.entries(newMarket); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key !== 'marketOutcome') {
                if (exMarket.hasOwnProperty(key) && exMarket[key] !== value) {
                    exMarket[key] = value;
                    if (eventMapping[String(newMarket.e)].highlightedMarkets && eventMapping[String(newMarket.e)].highlightedMarkets[exMarket.mST]) {
                        fillHighLightedMarkets(eventMapping[String(newMarket.e)], exMarket.mST);
                    }
                    isUpdated = true;
                }
            }
            else {
                exMarket[key].forEach(function (outcome) {
                    var incomingMarketOutcome = newMarket['marketOutcome'].find(function (el) { return el.oNo === outcome.oNo; });
                    if (incomingMarketOutcome) {
                        if (outcome.fOW !== incomingMarketOutcome.fOW || Number(outcome.oV) <= Number(incomingMarketOutcome.oV)) {
                            if (Number(outcome.fOW) < Number(incomingMarketOutcome.fOW)) {
                                outcome.isUpdated = 'up';
                            }
                            else if (Number(outcome.fOW) > Number(incomingMarketOutcome.fOW)) {
                                outcome.isUpdated = 'down';
                            }
                            outcome.fOW = incomingMarketOutcome.fOW;
                            if (member && member.additional_ratio && Number(member.additional_ratio) > 0) {
                                outcome.fOW = Number(outcome.fOW) + Number(member.additional_ratio);
                                outcome.customOdds = Number(outcome.fOW);
                                event.hasCustomratio = true;
                            }
                            else {
                                outcome.customOdds = null;
                            }
                            setTimeout(function () {
                                outcome.isUpdated = null;
                                eventUpdateSubject.next([String(newMarket.e)]);
                            }, 5000);
                            isUpdated = true;
                        }
                    }
                });
            }
        }
    }
    return isUpdated;
}
export function addToSportsBook(newEvent) {
    var updated = false;
    if (newEvent && (newEvent.iLE === '1' && eventEndedStatuses.indexOf(newEvent.liveScoreStatus) === -1) && (newEvent.iLE === '0' && new Date(newEvent.eD) >= ServerDate())) {
        eventMapping[newEvent.eventId.toString()] = newEvent;
        marketMapping[newEvent.eventId.toString()] = newEvent.markets.filter(function (m) { return Number(m.mS) < 2; });
        marketMapping[newEvent.eventId.toString()].forEach(function (market) {
            if (!marketIdMapping[newEvent.eventId.toString()]) {
                marketIdMapping[newEvent.eventId.toString()] = {};
            }
            marketIdMapping[newEvent.eventId.toString()][market.marketId.toString()] = market;
        });
        newEvent.markets = [];
        fillHighLightedMarkets(eventMapping[newEvent.eventId.toString()]);
        sportsbookList.push(eventMapping[newEvent.eventId.toString()]);
        updated = true;
    }
    return updated;
}
export function getUpdateFromSportsbook(apiUrl) {
    var apiService = new ApiService();
    apiService.start('get', apiUrl, null, false)
        .then(function (response) {
        var updated = [];
        if (response.status) {
            response.data.forEach(function (incomeEvent) {
                var exEvent = eventMapping[incomeEvent.eventId.toString()];
                if (!exEvent) {
                    if (addToSportsBook(incomeEvent)) {
                        updated.push(incomeEvent.eventId.toString());
                    }
                }
                else {
                    if (compireEventKeys(exEvent, incomeEvent)) {
                        updated.push(incomeEvent.eventId.toString());
                    }
                    for (var _i = 0, _a = incomeEvent.markets; _i < _a.length; _i++) {
                        var market = _a[_i];
                        if (!marketIdMapping[exEvent.eventId][market.marketId.toString()] || (Number(marketIdMapping[exEvent.eventId][market.marketId.toString()].marketVersion) <= Number(market.marketVersion))) {
                            if (compireMarketKeys(exEvent, marketIdMapping[exEvent.eventId][market.marketId.toString()], market)) {
                                updated.push(incomeEvent.eventId.toString());
                            }
                        }
                    }
                    var removedMarkets = [];
                    var _loop_2 = function (market) {
                        var marketIndex = incomeEvent.markets.find(function (el) { return Number(el.marketId) === Number(market.marketId); });
                        if (!marketIndex) {
                            var ex = marketMapping[exEvent.eventId].findIndex(function (el) { return Number(el.marketId) === Number(market.marketId); });
                            marketMapping[exEvent.eventId].splice(ex, 1);
                            delete marketIdMapping[exEvent.eventId][market.marketId.toString()];
                            removedMarkets.push(market.marketId);
                            updated.push(exEvent.eventId.toString());
                        }
                    };
                    for (var _b = 0, _c = marketMapping[exEvent.eventId]; _b < _c.length; _b++) {
                        var market = _c[_b];
                        _loop_2(market);
                    }
                }
            });
            // const incomingIds = new Set(response.data.map((e: SportEvent) => e.eventId.toString()));
            // for (let i = sportsbookList.length - 1; i >= 0; i--) {
            //     const ev = sportsbookList[i];
            //     if (!incomingIds.has(ev.eventId.toString())) {
            //         if (ev.isAdded) {
            //             addToBetSlip(ev, null, null, 'removeEvent');
            //         }
            //         delete eventMapping[ev.eventId];
            //         delete marketMapping[ev.eventId];
            //         delete marketIdMapping[ev.eventId];
            //         delete statisticsMap[ev.eventId];
            //         sportsbookList.splice(i, 1);
            //     }
            // }
        }
        if (updated.length > 0) {
            eventUpdateSubject.next(updated);
        }
    });
}
